module.exports = __webpack_public_path__ + "media/shangjia.6f196ea1.mp3";